import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

export default function FinanciarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Tarif" value={data.tarifSuma} onChange={update("tarifSuma")} placeholder="ex: 5000" type="number" required half error={errors.tarifSuma} />

      <SelectField
        label="Moneda"
        value={data.tarifMoneda}
        onChange={update("tarifMoneda")}
        options={[
          { value: "RON", label: "RON" },
          { value: "EUR", label: "EUR" },
        ]}
        half
      />

      <SelectField
        label="Tip tarif"
        value={data.tipTarif}
        onChange={update("tipTarif")}
        options={[
          { value: "ora", label: "Pe ora" },
          { value: "zi", label: "Pe zi" },
          { value: "luna", label: "Pe luna" },
          { value: "proiect", label: "Suma fixa per proiect" },
        ]}
        half
      />

      <SelectField
        label="Termen de plata"
        value={data.termenPlata}
        onChange={update("termenPlata")}
        options={[
          { value: "factura", label: "La emiterea facturii" },
          { value: "factura15", label: "15 zile de la factura" },
          { value: "factura30", label: "30 zile de la factura" },
          { value: "finalizare", label: "La finalizarea proiectului" },
        ]}
        half
      />
    </div>
  );
}
